var _style, _rect, _defs, _defs2, _defs3, _rect2, _defs4, _defs5, _defs6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45.3 57.16",
    style: {
      enableBackground: "new 0 0 45.3 57.16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{enable-background:new    ;}\n\t.st2{clip-path:url(#SVGID_00000026147713845802433210000006086369896321633160_);}\n\t.st3{clip-path:url(#SVGID_00000000193766439023559860000009286264778444787112_);}\n\t.st4{clip-path:url(#SVGID_00000152956753455864830290000008486907644250553528_);fill:#55BBB1;}\n\t.st5{clip-path:url(#SVGID_00000048478809556220554320000010569815427915736450_);}\n\t.st6{clip-path:url(#SVGID_00000134959709070144601800000016187162674533330604_);}\n\t.st7{clip-path:url(#SVGID_00000054252717611866960460000003156077109058735243_);fill:#55BBB1;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 42,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAhCAYAAABAxlKmAAAACXBIWXMAAAsSAAALEgHS3X78AAAB +ElEQVRYhdWYS27DMAxEKSN36qJ3ymF6pyxyqNpdtDTo0QxFuUmAEBDsyBT1LPHjyOyNpFUVr/db WXdWvj4+t4qeBHgmXEXYC1CgAeijX0KuKgJ3EyegTdwr3crWok43JgLvk05CVnRTCOjfSN8uDnwR RnBihBytsvdtQieDl7uyiEERCtsSrqq1RAdtoP3u5XzXL/HHABjh8RmOi8K2eSP9De4PK8zcALc4 a0auShAM20qAD6J8VsFVtq2ysghpf7ZX0D2sLsKyLUX/O7PCuPWxWQBOA1G5AUJg0DwKdhU2Ohe4 3m8tS10InrnDGVgH9Yz0bTxt7X0X6GSgGXSactiEQRxyBR3MMNJnGXgVOINlgoHkTZZpVRQyUTl2 lBFm9To5A+vCkjq7Z+Mqep2MAiybjPrVYBymrJnxEhYrCbZmx7SDZZLZU7ZU+U1hcSJmKFYcBYg2 YtDEIlCBHhaFKHEyB/WyWCm3bLsrjY2lsMqfZkGVzewjhrmBzLPMFRzSgdFPM8gZYLXCZvb7byEL MIfAGj67qgwUrwpy6LMYFFhV4upPJXUBPAwsl8WM/kfPvpLwylr2jOky0FKAReCsVmNtV8/OVLPO X81CuRVHOCrXZtFc6T9VGDqfe/FpjIsEpIccKP8465Jf+zNSPuti8uyDuupJ4tvID1zHKzr/EKuV AAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 2.5941 33.6844)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.59,
    y: 33.68,
    className: "st0",
    width: 42,
    height: 32
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 12.59,
    y: 43.68,
    width: 22,
    height: 12
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060017313434780972180000018139066071503784851_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060017313434780972180000018139066071503784851_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000181046346343224863730000000769870630349216655_",
    d: "M26.34,51.52c0.08,1.96,1.67,3.17,4.1,3.17 c2.55,0,4.16-1.27,4.16-3.28c0-1.58-0.91-2.47-3.05-2.97l-1.21-0.28c-1.29-0.31-1.83-0.72-1.83-1.43c0-0.88,0.8-1.47,1.99-1.47 c1.21,0,2.03,0.6,2.12,1.59h1.8c-0.04-1.87-1.58-3.14-3.9-3.14c-2.29,0-3.92,1.27-3.92,3.16c0,1.52,0.92,2.46,2.86,2.91 l1.37,0.32c1.33,0.32,1.87,0.76,1.87,1.52c0,0.88-0.88,1.52-2.16,1.52c-1.29,0-2.26-0.64-2.37-1.62L26.34,51.52L26.34,51.52z  M20.57,45.33c1.88,0,3.08,1.5,3.08,3.87c0,2.36-1.2,3.87-3.08,3.87c-1.89,0-3.08-1.5-3.08-3.87 C17.5,46.83,18.69,45.33,20.57,45.33z M20.57,43.71c-3.08,0-5,2.11-5,5.49s1.93,5.49,5,5.49c3.07,0,5-2.11,5-5.49 S23.64,43.71,20.57,43.71z M13.6,45.68c0.57,0,1.02-0.44,1.02-0.99c0-0.56-0.45-1-1.02-1c-0.56,0-1.01,0.44-1.01,1 C12.59,45.24,13.04,45.68,13.6,45.68z M12.7,54.51h1.82v-7.8H12.7V54.51z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104677870480127631990000002588564889641428635_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181046346343224863730000000769870630349216655_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000104677870480127631990000002588564889641428635_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000159439080245495456130000018419692855155701942_",
    x: 2.59,
    y: 33.68,
    width: 42,
    height: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009586168554641773210000010194116682722218410_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159439080245495456130000018419692855155701942_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.59,
    y: 42.68,
    style: {
      clipPath: "url(#SVGID_00000009586168554641773210000010194116682722218410_)",
      fill: "#55BBB1"
    },
    width: 24,
    height: 13
  }))))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 51,
    height: 58,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA7CAYAAAA0Lqk+AAAACXBIWXMAAAsSAAALEgHS3X78AAAE mElEQVRoge2aTZLTMBCFO07mTCy4E4fhTiw4EgyxWZDOPD+/12qFzBQLukolR7FlfeoftWVH/Jd/ W04fcZMv3789fJ+vnz5vM+e/G9DfQCjpgr0LUAHTvZ8cfAfq0rxBWwTMyRw72eC8KXOLeDJQAcN1 RxJsCurpGgI5hQdSYFvsIbhu3/QpQtphmJNoQ9mg5oL/D/3oPTSkwFRJGWnhY03ORDQe/CLaUFIb K7Vhfy2wKaDB2qJMbAkPhINE81qpv4hn+1BzXcGZZ5AljlA4WNRQlg1q9inrSyVQYU58jLWDGQGt piBYxADKAk2sKcqUFAy25XVoZliuBmynJQUlgQYwVUhm7ZwFmNIQg3BtTY+hDkHBwDCEcnLlL6wh BsLF1C22KWvx311GUc6tIZXTKwg+H2U1QKgNjoohft8b72JWewZRgxwVpVXlP9db+UU1ml8Z9ZyG 3JqS5Uz1DBD2v97ac8ApOdhzaLO069IdaBAIGOQCv8/hwUZZAgYE5Vvb7XrUxlX0cQQikMrMLjeA rB1UlSHgoFM7qj37wrRI+k4FhGA4sIS4iGMEOscYhgd+ukGprGGJvQZVgLBAVSDAgV9EURpyMAm0 hod0/ZRyiWhlzAx1iYiXCaAIPXDnU85suR8NNAGTPoTlJY5mN5pVF7mUqYaop4CwI15rOAhwgEAf qgahnn2qYNKCUUBqYVXhWEEpDXG/mDHj/+z0ajwtQaDZLIEjG/pQx9zSVzZxTSsAjIAYrANVZQaj Aan+FdAU2Cj16dx4EceL6Q/XjtQOT6C6zkXhw1rU3VPozGbHXDhEz2oI2+TCyjPZERdOZ02kcv7p /nMtfQRoM8dVG0o1eB74SPOHti4QP/by8eGxuClOEyMTtFbggNTg1TYt78QcdmaMOL8YBZ2hnyKQ GhSuGZgBd6A64mCqJFddL4FQnDbcHpqCe4YvTa9PHLZxXRhBsNYqU+BwzcBVNHNtfK3dU1Az7XY1 r6EfwFjzrC2nUT7P+ZqVJUJuqSr/wcdlLGqnk39X/eE2L8I/FDm7JofaOAPMEn+2mtjUMK1RM5oD rfazq+jaBkIoZ24IgpEIbz5KUnGwqPWRhvn6w2+Xy+EMngRMltQOXtcBwnOxb9xYrF6rhKgjApwX /Mipm2/syquoXwfnZGH/zKLWwANMRJ1ts5ZO8bZ/xiEaoZd406QKuW6yEEABlm8gukDpSxUUDspt lCigiL1J8d62Mj/lTzvZrRdkdlkrk8ubslm9RsRPU37cCv7mc5R5soZKTXVMLo9xlwZ3OSN00CiT SDEonjC3xkntpDIOuZx5GVvZO2upoxmlHdYQRj3eJrZ+NHoE5wtWaM9yDr3bGeHTFWXa7E8uZzzA oBJktk1aUqaBN8DZRC1VfvUqigvf7YAQMffhBUenjHC58PILLZVYqr6qFGf07NV7C54iXlHyYKvn lC4QwuCxattdO/WdQkrjFT+3tfolcemMTXPclyTDTRLzaJE1rw0cel027c5zZjb0nZT2TE58Rzqr nRS3XOxk9L3c9M0nv/atzm3NOErnI9pHZ/Muz/6cOWX2e+2U38zhDI6MJ4E1AAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 -2.4059 -8.3156)"
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2.41,
    y: -8.32,
    className: "st0",
    width: 51,
    height: 58
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000006696768184278247730000009213832621478994623_",
    x: 7.59,
    y: 1.68,
    width: 31,
    height: 38
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127723659659785954080000010945950976740936588_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006696768184278247730000009213832621478994623_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127723659659785954080000010945950976740936588_)"
    }
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044880030038329144190000017770753221542153908_",
    d: "M28.69,7.74c1.18-1.4,2.02-3.35,2.02-5.29 c0-0.27-0.02-0.54-0.07-0.76c-1.93,0.07-4.22,1.28-5.6,2.88c-1.09,1.23-2.1,3.18-2.1,5.15c0,0.3,0.05,0.59,0.07,0.69 c0.12,0.02,0.32,0.05,0.52,0.05C25.26,10.45,27.44,9.3,28.69,7.74z M37.6,14.64c-0.22,0.17-4.12,2.36-4.12,7.24 c0,5.64,4.96,7.63,5.11,7.68c-0.02,0.12-0.79,2.73-2.62,5.39c-1.63,2.34-3.33,4.68-5.92,4.68s-3.26-1.5-6.24-1.5 c-2.91,0-3.95,1.55-6.32,1.55s-4.02-2.17-5.92-4.83c-2.2-3.12-3.98-7.98-3.98-12.58c0-7.39,4.81-11.31,9.55-11.31 c2.52,0,4.62,1.65,6.2,1.65c1.5,0,3.85-1.75,6.71-1.75C31.14,10.87,35.04,10.97,37.6,14.64z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090988992597038056260000000773380864915094202_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044880030038329144190000017770753221542153908_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000090988992597038056260000000773380864915094202_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000087389271970513866010000003357449502820971448_",
    x: -2.41,
    y: -8.32,
    width: 51,
    height: 58
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127023095388885907660000006096624054392896166_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087389271970513866010000003357449502820971448_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.59,
    y: 0.68,
    style: {
      clipPath: "url(#SVGID_00000127023095388885907660000006096624054392896166_)",
      fill: "#55BBB1"
    },
    width: 33,
    height: 40
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.8fc1906ca6e8adc5c9ce4ed9ed21e3ef.svg";
export { ForwardRef as ReactComponent };